var OperationTraceIdMap = {};
export var startCapturingTraceIds = function startCapturingTraceIds(operationName) {
  OperationTraceIdMap[operationName] = OperationTraceIdMap[operationName] || [];
};
export var stopCapturingTraceIds = function stopCapturingTraceIds(operationName) {
  OperationTraceIdMap[operationName] = undefined;
};
export var addTraceId = function addTraceId(operationName, traceId) {
  if (traceId !== undefined) {
    var traceIdsForOperation = OperationTraceIdMap[operationName];
    if (traceIdsForOperation !== undefined) {
      traceIdsForOperation.push(traceId);
    }
  }
};
export var getTraceIds = function getTraceIds(operationName) {
  return OperationTraceIdMap[operationName] || [];
};